import { SortOrder } from "../hooks/types";
export var getCurrentSortDetails = function (sortOptionsConfig) {
    return function (sort) {
        if (!sort) {
            return undefined;
        }
        var keys = Object.keys(sort);
        switch (keys.length) {
            case 0:
                return undefined;
            case 1:
                var key = keys[0];
                var order = sort[key].Order;
                var sortOption = sortOptionsConfig[key];
                if (!sortOption) {
                    throw new Error("The column ".concat(key, " is not sortable."));
                }
                var sortField = sortOption.sortField;
                if (!sortField) {
                    return { key: key, order: order, sortField: key };
                }
                if (typeof sortField === "string" || typeof sortField === "number") {
                    return { key: key, order: order, sortField: sortField };
                }
                return { key: key, order: order, sortField: sortField[order] };
            default:
                throw new Error("SearchX currently only supports one column sorting. Got ".concat(keys.length, ": ").concat(keys.join(", "), "."));
        }
    };
};
export var getCurrentSortInfo = function (sortOptionsConfig) {
    return function (sortDetails, allowMultiMatch) {
        var sortField = sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.sortField;
        if (sortField) {
            var sortOptions = Object.entries(sortOptionsConfig).filter(function (_a) {
                var info = _a[1];
                if (typeof info.sortField === "object") {
                    return (info.sortField[SortOrder.Ascending] === sortField ||
                        info.sortField[SortOrder.Descending] === sortField);
                }
                else {
                    return info.sortField === sortField;
                }
            });
            if (sortOptions.length) {
                if (!allowMultiMatch) {
                    sortOptions = sortOptions.slice(0, 1);
                }
                return sortOptions.reduce(function (cur, _a) {
                    var key = _a[0], info = _a[1];
                    if (typeof info.sortField === "object") {
                        cur[key] = {
                            Order: info.sortField[SortOrder.Ascending] === sortField
                                ? SortOrder.Ascending
                                : SortOrder.Descending,
                        };
                    }
                    else if ((sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.order) != null) {
                        cur[key] = { Order: sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.order };
                    }
                    return cur;
                }, {});
            }
        }
    };
};
//# sourceMappingURL=sort.js.map